<section class="container-nm px-4 pt-4 w-100 mx-auto step_mobile" style="box-sizing: border-box;">
<div class="title-page">
    <span>{{ 'gameInfo.txtEditTitle' | translate }}</span>
</div>
<div class="line"></div>
<div class="description-page">
    <span>{{ 'gameInfo.txtPrepGame' | translate }}</span>
</div>
<app-tmp-wt-player-info [player]="players.player" [maximumPlayers]="gameInfo.gameInfo.room.maximum_players" [selectType]="this.gameInfo.gameInfo.room.type" [availableRQs]="changeAvailable(rdUse.game$?.available_rqs ?? [])" [allPlayers]="rdUse.game$?.players || []"></app-tmp-wt-player-info>
</section>

